export default {
  'emailTemplates.mailFormat': 'Email Template',
  'emailTemplates.seeAdvancedEdition': 'See Advanced Edition',
  'emailTemplates.hideAdvancedEditing': 'Hide Advanced Editing',
  'emailTemplates.form.subject': 'Subject',
  'emailTemplates.form.fromName': 'From Name',
  'emailTemplates.form.htmlContent': 'HTML Content',
};
